/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=35666ad7&scoped=true"
import script from "./CreateDialog.vue?vue&type=script&lang=js"
export * from "./CreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35666ad7",
  null
  
)

export default component.exports